import { useNavigate } from 'react-router'
import SettingsSuggestRoundedIcon from '@mui/icons-material/SettingsSuggestRounded'
import Box from '@mui/material/Box'
import ButtonBase from '@mui/material/ButtonBase'
import Typography from '@mui/material/Typography'

export function WizardButton({
    estateId = 0,
    applianceId = 0,
}: {
    estateId?: number | string
    applianceId?: number | string
}) {
    const navigate = useNavigate()

    return (
        <ButtonBase
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                backgroundColor: 'customBeige.main',
                //backgroundColor: 'customGrey.main',
                paddingX: 1.5,
                paddingY: 1.5,
                paddingRight: 2.2,
                borderRadius: 5,
                color: 'primary.main',
                "&.Mui-focusVisible": {
                    backgroundColor: 'customBeige.dark',
                    //backgroundColor: 'customGrey.dark',
                },
                boxShadow: '0 1px 3px rgba(0, 0, 0, .3)',
                // animation: 'pulse 1.5s infinite',
                // "@keyframes pulse": {
                //     "0%": { opacity: 1 },
                //     "50%": { opacity: 0.5 },
                //     "100%": { opacity: 1 },
                // },
            }}
            component="div"
            onClick={() => {
                navigate(`/wizard/${estateId ? estateId : '0'}/${applianceId ? applianceId : ''}`)
            }}
        >
            <Box sx={{
                paddingRight: 1.5,
                fontSize: '1.5rem',
                lineHeight: 0,
            }}>
                <SettingsSuggestRoundedIcon fontSize='inherit'/>
            </Box>
            <Typography component="div" sx={{ fontSize: '1rem', fontWeight: 500 }}>Rychlé nastavení</Typography>
        </ButtonBase>
    )
}
